import React, { createContext, useContext, useMemo } from "react";

const ROLE_KEY = "QV_ROLE"; // 'admin' | 'subadmin' | 'subsubadmin'
const SOCIETY_KEY = "QV_SOCIETY_ID";

const AuthContext = createContext({
  role: "guest",
  societyId: null,
  isAdmin: false,
  isSubadmin: false,
  isSubSubAdmin: false, // Add this property
  id: null,
});

export const AuthProvider = ({ children }) => {
  let role = "guest";
  let societyId = null;
  let id = null;
  try {
    role = sessionStorage.getItem(ROLE_KEY) || "guest";
    societyId = sessionStorage.getItem(SOCIETY_KEY) || null;
    // Prioritize document ID for all admin roles
    id =
      sessionStorage.getItem("QV_ADMIN_DOC_ID") ||
      localStorage.getItem("QV_ADMIN_DOC_ID") ||
      sessionStorage.getItem("adminToken") ||
      localStorage.getItem("adminToken") ||
      null;
  } catch {}

  const value = useMemo(
    () => ({
      role,
      societyId,
      isAdmin: role === "admin",
      isSubadmin: role === "subadmin",
      isSubSubAdmin: role === "subsubadmin",
      isVendorAdmin: role === "vendor_admin",
      id,
    }),
    [role, societyId, id],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
